<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'
import SearchFilterToolbarSearchField from "./SearchFilterToolbarSearchField.vue"
import SearchFilterToolbarFiltersBtn from "./SearchFilterToolbarFiltersBtn.vue"
import SearchFilterToolbarFilterOffcanvas from "./SearchFilterToolbarFilterOffcanvas.vue"
import SearchFilterToolbarFilter from "./SearchFilterToolbarFilter.vue"

const props = defineProps({
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed properties
const showSearchToolbar = computed(() => {
    return !!viewStore.showSearchToolbar
})

const filters = computed(() => {
    return viewStore.filters || []
})

const offCanvasId = computed(() => {
    if (!props.viewId) return 'default__offcanvas'
    return props.viewId.replace(':', '__') + '__offcanvas'
})
</script>

<template>
    <transition name="fadeHeight">
        <div v-if="showSearchToolbar" class="d-flex flex-wrap align-items-center gap-1 border-bottom px-3 py-1">
            <SearchFilterToolbarSearchField :view-id="viewId" class="me-1"/>

            <!-- Swapped loop :key from index 'i' to unique structure metrics to preserve proper element destruction -->
            <SearchFilterToolbarFilter
                v-for="(filter, i) in filters"
                :key="filter.id || `${filter.columnName}-${filter.type}-${i}`"
                :view-id="viewId"
                :off-canvas-id="offCanvasId"
                :filter-key="i"
                class="me-1"
            />

            <SearchFilterToolbarFiltersBtn :view-id="viewId" :off-canvas-id="offCanvasId"/>
            <SearchFilterToolbarFilterOffcanvas :view-id="viewId" :off-canvas-id="offCanvasId"/>
        </div>
    </transition>
</template>

<style scoped>
.fadeHeight-enter-active,
.fadeHeight-leave-active {
    transition: all 0.2s;
    max-height: 50px;
}

.fadeHeight-enter,
.fadeHeight-leave-to {
    opacity: 0;
    max-height: 0;
}
</style>